'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # Passive Events
 * Detect whether passive events are supported by a browser
 * Adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 *
 *
 * @module helpers/util/passive-events.js
 */

function supportsPassiveEvents() {
  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
        return false;
      }
    });

    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    // Catch errors
  }

  return supportsPassive;
}

exports.default = supportsPassiveEvents;
module.exports = exports['default'];
//# sourceMappingURL=passive-events.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/helpers/util/passive-events.js
// module id = 813
// module chunks = 0